import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-global-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading font-bold text-lg text-background-50 whitespace-nowrap">
                亚洲精品一区二区
              </span>
            </Link>
            <p className="text-background-400 text-sm leading-relaxed">
              精选内容分区导览平台，汇聚亚洲优质内容，提供精准分类、快速定位的内容发现服务。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">快速导航</h4>
            <nav className="flex flex-col gap-2.5">
              <Link to="/" className="text-background-400 hover:text-background-200 text-sm transition-colors cursor-pointer">首页</Link>
              <Link to="/category/yiqu" className="text-background-400 hover:text-background-200 text-sm transition-colors cursor-pointer">一区精品</Link>
              <Link to="/category/erqu" className="text-background-400 hover:text-background-200 text-sm transition-colors cursor-pointer">二区资源</Link>
              <Link to="/category/zonghe" className="text-background-400 hover:text-background-200 text-sm transition-colors cursor-pointer">综合导览</Link>
            </nav>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">热门分类</h4>
            <nav className="flex flex-col gap-2.5">
              <Link to="/category/yiqu-tuijian" className="text-background-400 hover:text-background-200 text-sm transition-colors cursor-pointer">热门推荐</Link>
              <Link to="/category/yiqu-jingxuan" className="text-background-400 hover:text-background-200 text-sm transition-colors cursor-pointer">编辑精选</Link>
              <Link to="/category/erqu-heji" className="text-background-400 hover:text-background-200 text-sm transition-colors cursor-pointer">精品合集</Link>
              <Link to="/category/zonghe-paihang" className="text-background-400 hover:text-background-200 text-sm transition-colors cursor-pointer">排行榜单</Link>
            </nav>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">关于我们</h4>
            <nav className="flex flex-col gap-2.5">
              <Link to="/about" className="text-background-400 hover:text-background-200 text-sm transition-colors cursor-pointer">品牌介绍</Link>
              <Link to="/about" className="text-background-400 hover:text-background-200 text-sm transition-colors cursor-pointer">用户口碑</Link>
              <Link to="/about" className="text-background-400 hover:text-background-200 text-sm transition-colors cursor-pointer">联系我们</Link>
            </nav>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-background-500 text-xs">
            &copy; 2025 亚洲精品一区二区. 保留所有权利.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-500 hover:text-background-300 text-xs transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-background-500 hover:text-background-300 text-xs transition-colors cursor-pointer" rel="nofollow">使用条款</a>
            <a href="#" className="text-background-500 hover:text-background-300 text-xs transition-colors cursor-pointer" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}